import { useContext } from 'react';
import { TabContext } from '../../Context/TabContext';
import Pocetna from '../Pocetna/Pocetna';
import Meniji from '../Administracija/Meniji/Meniji';
import OpcijePrograma from '../Administracija/OpcijePrograma/OpcijePrograma';
import OpcijeMenija from '../Administracija/OpcijeMenija/OpcijeMenija';
import Scheduler from '../UI/Calendar/Scheduler';
import NotificationsTabList from '../UI/Notifications/NotificationsTabList';
import MuiGridProvider from '../UI/MuiGrid/MuiGridProvider';

import Masine from '../Sifarnici/Masine';
import ZahtevZaServis from '../Sifarnici/ZahtevZaServis';
import PregledPorudzbina from '../Sifarnici/PregledPorudzbina';
import Lokacije from '../Sifarnici/Lokacije';
import ZahtevZaServisPregled from '../Sifarnici/ZahtevZaServisPregled';
import KorisniciPrograma from '../Sifarnici/KorisniciPrograma';
import Ponude from '../Sifarnici/Ponude';
import Zaposleni from '../Sifarnici/Zaposleni';
import RadniNalozi from '../Sifarnici/RadniNalozi';
import PregledRadnogNaloga from '../Sifarnici/PregledRadnogNaloga';
import KlijentiPregled from '../Sifarnici/KlijentiPregled';
import Klijent from '../Sifarnici/Klijent';
import DobitPoRadnimNalozima from '../Sifarnici/DobitPoRadnimNalozima';
import ZahtevZaServisInmold from '../Sifarnici/ZahtevZaServisInmold';
import Porudzbenice from '../Sifarnici/Porudzbenice';
import PorudzbenicaPregled from '../Sifarnici/PorudzbenicaPregled';
import DobitDetaljniPregled from '../Sifarnici/DobitDetaljniPregled';
import PonudeDetalji from '../Sifarnici/PonudeDetalji';
import PregledKlijenata from '../Sifarnici/PregledKlijenata';
import VrstaUsluge from '../Sifarnici/VrsteUsluga';
import Prodavnica from '../Sifarnici/Prodavnica';
import ProdavnicaKorpa from '../Sifarnici/ProdavnicaKorpa';
import UnosDelova from '../Sifarnici/UnosDelova';
import KategorijaDelova from '../Sifarnici/KategorijaDelova';
import RabatneGrupe from '../Sifarnici/RabatneGrupe';
import PregledServisaKlijenti from '../Sifarnici/PregledServisaKlijenti';
import NaruceniDelovi from '../Sifarnici/NaruceniDelovi';
import KarakteristikeMasina from '../Sifarnici/KarakteristikeMasina';
import PustanjeMasineURad from '../Sifarnici/PustanjeMasineURad';
import PregledPustanjaMasine from '../Sifarnici/PregledPustanjaMasine';
import StavkeRN from '../Sifarnici/StavkeRN';
import KategorijeDokumenata from '../Sifarnici/KategorijeDokumenata';
import ProgresProjekta from '../Sifarnici/ProgresProjekta';

function ActiveComponent(props) {
  const tabContext = useContext(TabContext);

  const properties = {
    handleData: props.handleData,
    data: props.data,
    sendRequest: props.sendRequest,
    isLoading: props.isLoading,
    handleRefreshData: props.handleRefreshData,
    error: props.error,
    isSuccess: props.isSuccess,
    clearError: props.clearError,
    handleZakljuciDok: props.handleZakljuciDok,
    handleObrisiDok: props.handleObrisiDok,
    obrisiDok: props.obrisiDok,
    isOdobren: props.isOdobren,
    isDeleted: props.isDeleted,
    handleStornirajDok: props.handleStornirajDok,
    isStorniran: props.isStorniran,
    disabledBtn: props.disabledBtn,
    handleDisableBtn: props.handleDisableBtn,
    disableBtnNovi: props.disableBtnNovi,
    handleDisableBtnNovi: props.handleDisableBtnNovi,
    zatvoriDok: props.zatvoriDok,
    handleZatvoriDok: props.handleZatvoriDok,
    handlePregledDok: props.handlePregledDok,
    pregledDok: props.pregledDok,
    onSetData: props.onSetData,
    handleSendEmail: props.handleSendEmail,
    sendEmail: props.sendEmail,
    handleDodajAktivnost: props.handleDodajAktivnost,
    dodajAktivnost: props.dodajAktivnost,
    handleDodajPosao: props.handleDodajPosao,
    dodajPosao: props.dodajPosao,
    handleKopiraj: props.handleKopiraj,
    handleVerzija: props.handleVerzija,
    kopiraj: props.kopiraj,
    verzija: props.verzija,
    handleStampa: props.handleStampa,
    stampa: props.stampa,
    handleTemplate: props.handleTemplate,
    template: props.template,
    handleMesecni: props.handleMesecni,
    mesecni: props.mesecni,
    handlePlanIsplate: props.handlePlanIsplate,
    planIsplate: props.planIsplate,
    info: props.info,
    handleInfo: props.handleInfo,
    novi: props.novi,
    handleNovi: props.handleNovi,
    prikaziSveArtikle: props.prikaziSveArtikle,
    handlePrikaziSveArtikle: props.handlePrikaziSveArtikle,
    save: props.save,
    handleSave: props.handleSave,
    deklaracije: props.deklaracije,
    handleDeklaracije: props.handleDeklaracije,
    disableDeklaracije: props.disableDeklaracije,
    handleDisableDeklaracije: props.handleDisableDeklaracije,
    handleOsvezi: props.handleOsvezi,
    osvezi: props.osvezi,
    handleDisablelogo: props.handleDisablelogo,
    disableLogo: props.disableLogo,
    handleLogo: props.handleLogo,
    logo: props.logo,
    handlePromenaStatusa: props.handlePromenaStatusa,
    promenaStatusa: props.promenaStatusa,
    handleDisablePromenaStatusa: props.handleDisablePromenaStatusa,
    handleDisableStavka: props.handleDisableStavka,
    stavka: props.stavka,
    handleStavka: props.handleStavka,
    disableStavka: props.disableStavka,
    prikaziSve: props.prikaziSve,
    handlePrikaziSve: props.handlePrikaziSve,
    matricaVestina: props.matricaVestina,
    handleMatricaVestina: props.handleMatricaVestina,
    handleDisableMatricaVestina: props.handleDisableMatricaVestina,
    matricaZapisa: props.matricaZapisa,
    handleMatricaZapisa: props.handleMatricaZapisa,
    handleDisableMatricaZapisa: props.handleDisableMatricaZapisa,
    pregledPlana: props.pregledPlana,
    handlePregledPlana: props.handlePregledPlana,
    handleDisablePregledPlana: props.handleDisablePregledPlana,
    mesecniPlan: props.mesecniPlan,
    handleMesecniPlan: props.handleMesecniPlan,
    handleDisableMesecniPlan: props.handleDisableMesecniPlan,
    ostvareniPlan: props.ostvareniPlan,
    handleOstvareniPlan: props.handleOstvareniPlan,
    handleDisableOstvareniPlan: props.handleDisableOstvareniPlan,
    izmenaPlana: props.izmenaPlana,
    handleIzmenaPlana: props.handleIzmenaPlana,
    handleDisableIzmenaPlana: props.handleDisableIzmenaPlana,
    planPoseta: props.planPoseta,
    handlePlanPoseta: props.handlePlanPoseta,
    handleDisablePlanPoseta: props.handleDisablePlanPoseta,
    dodajAtribut: props.dodajAtribut,
    handleDodajAtribut: props.handleDodajAtribut,
    handleDisableDodajAtribut: props.handleDisableDodajAtribut,
    disableDodeliZaposlenima: props.disableDodeliZaposlenima,
    handleDisableDodeliZaposlenima: props.handleDisableDodeliZaposlenima,
    posalji: props.posalji,
    handlePosalji: props.handlePosalji,
    handleDisablePosalji: props.handleDisablePosalji,
    novaMasina: props.novaMasina,
    handleNovaMasina: props.handleNovaMasina,
    noviRadniNalog: props.noviRadniNalog,
    handleNoviRadniNalog: props.handleNoviRadniNalog,
    handleShop: props.handleShop,
    shop: props.shop,
    handleDetail: props.handleDetail,
    detail: props.detail,
    handleDisableDetail: props.handleDisableDetail,
    numberOfArticles: props.numberOfArticles,
    handleDisableBtnNovaMasina: props.handleDisableBtnNovaMasina,
    dodeliZaposlenima: props.dodeliZaposlenima,
    handleDodeliZaposlenima: props.handleDodeliZaposlenima,
    handleDnevnik: props.handleDnevnik,
    dnevnik: props.dnevnik,
    handleBeleske: props.handleBeleske,
    beleske: props.beleske,
    izvestaji: props.izvestaji,
    handleIzvestaji: props.handleIzvestaji,
    handleDisableIzvestaji: props.handleDisableIzvestaji,
    kreirajDokument: props.kreirajDokument,
    handleKreirajDokument: props.handleKreirajDokument,
    handleDisableKreirajDokument: props.handleDisableKreirajDokument,
    pdfIzvestaj: props.pdfIzvestaj,
    handlePdfIzvestaj: props.handlePdfIzvestaj,
  };

  let component = null;
  switch (tabContext.activeComponent) {
    case '0':
      component = <Pocetna {...properties} />;
      break;
    case 3: // ovi brojevi su id-evi opcije programa
      component = <Meniji {...properties} />;
      break;
    case 4:
      component = <OpcijePrograma {...properties} />;
      break;
    case 5:
      component = <OpcijeMenija {...properties} />;
      break;
    case 110:
      component = <Scheduler {...properties} />;
      break;
    case 10000:
      component = <NotificationsTabList {...properties} />;
      break;
    case 1053:
      component = <MuiGridProvider {...properties} />;
      break;
    case 68:
      component = <Masine {...properties} />;
      break;
    case 10010:
      component = <ZahtevZaServis {...properties} />;
      break;
    case 10011:
      component = <PregledPorudzbina {...properties} />;
      break;
    case 69:
      component = <Lokacije {...properties} />;
      break;
    case 70:
      component = <KlijentiPregled {...properties} />;
      break;
    case 71:
      component = <ZahtevZaServisPregled {...properties} />;
      break;
    case 72:
      component = <KorisniciPrograma {...properties} />;
      break;
    case 74:
      component = <Ponude {...properties} />;
      break;
    case 73:
      component = <Zaposleni {...properties} />;
      break;
    case 75:
      component = <RadniNalozi {...properties} />;
      break;
    case 10012:
      component = <PregledRadnogNaloga {...properties} />;
      break;
    case 10013:
      component = <Klijent {...properties} />;
      break;
    case 1068:
      component = <DobitPoRadnimNalozima {...properties} />;
      break;
    case 1069:
      component = <Porudzbenice {...properties} />;
      break;
    case 10014:
      component = <ZahtevZaServisInmold {...properties} />;
      break;
    case 10015:
      component = <PorudzbenicaPregled {...properties} />;
      break;
    case 10016:
      component = <DobitDetaljniPregled {...properties} />;
      break;
    case 10017:
      component = <PonudeDetalji {...properties} />;
      break;
    case 1070:
      component = <PregledKlijenata {...properties} />;
      break;
    case 1071:
      component = <VrstaUsluge {...properties} />;
      break;
    case 1072:
      component = <Prodavnica {...properties} />;
      break;
    case 1073:
      component = <UnosDelova {...properties} />;
      break;
    case 1074:
      component = <KategorijaDelova {...properties} />;
      break;
    case 1075:
      component = <RabatneGrupe {...properties} />;
      break;
    case 10018:
      component = <ProdavnicaKorpa {...properties} />;
      break;
    case 10019:
      component = <PregledServisaKlijenti {...properties} />;
      break;
    case 10021:
      component = <NaruceniDelovi {...properties} />;
      break;
    case 1076:
      component = <KarakteristikeMasina {...properties} />;
      break;
    case 1077:
      component = <PustanjeMasineURad {...properties} />;
      break;
    case 10022:
      component = <PregledPustanjaMasine {...properties} />;
      break;
    case 1080:
      component = <StavkeRN {...properties} />;
      break;
    case 1082:
      component = <KategorijeDokumenata {...properties} />;
      break;
    case 1083:
      component = <ProgresProjekta {...properties} />;
      break;
    default:
      return component;
  }

  return <div style={{ width: '100vw', overflow: 'auto' }}>{component}</div>;
}

export default ActiveComponent;
